import React from 'react'
import styled, { css } from 'styled-components'
import { lighter } from '../helpers/color'
import { breakpoint } from '../layout/styles'
import { Container } from '../styles/Container'
import { Grid, Cell } from '../styles/Grid'
import Image from 'next/image'

const ImageList = ({ data }: any) =>
  <Wrapper>
    {data.content &&
      <div dangerouslySetInnerHTML={{ __html: data.content }} />}
    <Items alignment={data.items_alignment}>
      {data.items.map((item: any) =>
        <Section key={item.image.uid} background={lighter(data.background?.[0]?.background)} alignment={data.items_alignment} hasContent={!!(item.title || item.description)}>
          {item.image && (
            <ImageWrapper>
              <Image
                src={item.image.url}
                alt={item.image.alt || 'Image'}
                layout="fill"
                objectFit={item.title || item.description ? 'cover' : 'contain'}
                loading="lazy"
                placeholder="blur"
                blurDataURL={`${item.image.url}?width=10&height=10&quality=10`}
                quality={75}
              />
            </ImageWrapper>
          )}
          {(item.title || item.description) && (
            <Content>
              <h4>{item.title}</h4>
              <div dangerouslySetInnerHTML={{ __html: item.description }} />
            </Content>
            )}
        </Section>)}
    </Items>
    <div style={{ textAlign: 'center' }}>
      {data.call_to_action && data.call_to_action.href &&
        <Cta href={data.call_to_action.href}>{data.call_to_action.title}</Cta>}
    </div>
  </Wrapper>

export default ImageList

export const Wrapper = styled(Container)`
  margin: 36px 20px;
  color: var(--text);
  @media ${breakpoint.desktop} {
    margin: 0 auto 72px;
  }
`

export const Content = styled.div`
  padding: 1.5rem;
  @media ${breakpoint.desktop} {
    padding: 60px 50px;
    flex: 0 1 55%;
  }
`

const Items = styled.div<any>`
  ${props => props.alignment && props.alignment === 'horizontal' && css`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    @media ${breakpoint.tablet} {
      flex-direction: row;
    }

    &&& {
      img {
        width: auto;
      }
    }
  `}
`

const Section = styled(Cell)<{ hasContent: boolean }>`
  margin: 0;
  display: flex;
  flex-direction: column;
  background: ${props => props.background || 'none'};
  width: 100%;
  @media ${breakpoint.desktop} {
    margin: 32px 0;
    flex-direction: row;
  }
  @media ${breakpoint.tablet} {
    width: ${(props) => (props.hasContent ? '100%' : 'auto')};
  }
  h4 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    margin-top: 0;
    max-width: 420px;
  }
  p {
    font-size: 14px;
    @media ${breakpoint.desktop} {
      font-size: 16px;
    }
  }

  ${props => props.alignment && props.alignment === 'horizontal' && css`
    &:nth-child(even) {
      img {
        margin-left: 0;
      }
    }
    &:nth-child(odd) {
      img {
        margin-right: 0;
      }
    }
  `}
`

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: 320px;

  @media ${breakpoint.desktop} {
    max-height: none;
    flex: 1;
  }
`

export const Cta = styled.a`
  display: inline-block;
  cursor: pointer;
  background: #000;
  color: white;
  text-transform: uppercase;
  padding: 10px 20px;
  margin-top: 50px;
`